import { CoreFlightSteps } from "@b2bportal/core-utilities";
import { useValidateFlightShopRoute } from "@tenant/flights";

export const useReviewPageRoute = () => {
  const currentStep = CoreFlightSteps.REVIEW;
  useValidateFlightShopRoute(currentStep);
};
